import { createSelectorCreator, lruMemoize } from 'reselect';
import fastDeepEqual from 'fast-deep-equal';

// create a "selector creator" that uses lodash.isequal instead of ===
const createDeepEqualSelector = /* #__PURE__ */ createSelectorCreator(
    lruMemoize,
    fastDeepEqual
);

export { createDeepEqualSelector as default };
